import React from 'react';
import { createPortal } from 'react-dom';

const DEFAULT_ROOT_ID = 'candeza-overlay-root';

function getOrCreateRoot(rootId: string): HTMLElement {
  let root = document.getElementById(rootId);
  if (!root) {
    root = document.createElement('div');
    root.id = rootId;
    document.body.appendChild(root);
  }
  return root;
}

interface OverlayPortalProps {
  children: React.ReactNode;
  /** Override the shared root id — only needed for tests/isolation. */
  rootId?: string;
}

/**
 * Single shared portal target for every positioned/floating overlay
 * (tooltips, action menus, confirm dialogs, search results). Extends the
 * `document.body`-portal pattern already used by <Modal> so all overlays
 * share one stacking context ordered purely by theme.zIndex — see
 * docs/03-architecture/app-shell.md.
 */
export const OverlayPortal: React.FC<OverlayPortalProps> = ({ children, rootId = DEFAULT_ROOT_ID }) => {
  return createPortal(children, getOrCreateRoot(rootId));
};
